import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { my_filters } from 'store/modules/my_account_store/actions';
import Loader from 'components/atoms/loader';
import { ApplicationState } from 'store';
import { MyAccountState } from 'store/modules/my_account_store/types';
import ModalAddFilter from 'components/atoms/modal_add_filter';
// import ExclusionModal from 'components/atoms/exclusion_modal';
import Seta from 'assets/images/seta.svg';
// import EditFilterModal from 'components/atoms/edit_filter_modal';
import { openSupportChat } from 'services/support_chat';
import ViewFilter from '../view_filter';

const MyFilters = () => {
  const dispatch = useDispatch();
  const [showAddModal, setShowAddModal] = useState<boolean>(false);
  const [showEditModal, setShowEditModal] = useState<boolean>(false);
  // const [filterName, setFilterName] = useState<string>('');
  // const [dataFilter, setDataFilter] = useState<any>([]);
  const [view, setView] = useState<string>('filters');
  const [dadosFilters, setDadosFilters] = useState<object>();

  useEffect(() => {
    dispatch(my_filters());
  }, []);

  const { my_account, request } = useSelector<ApplicationState, MyAccountState>(
    (state) => state.session.my_account,
  );

  // const handleExclusion = (name: string) => {
  //   setFilterName(name);
  //   dispatch({ type: MyAccountTypes.OPEN_EXCLUSION_MODAL });
  // };

  // const handleEdit = (filter: any) => {
  //   setDataFilter(filter);
  //   setShowEditModal(true);
  // };

  const handleClickView = (filter: object) => {
    setView('filter');
    setDadosFilters(filter);
  };

  return (
    <div className="container-fluid">
      {view === 'filters' ? (
        <div className="card">
          {request?.my_filters.loading ? (
            <Loader />
          ) : (
            <div className="card-body">
              {/* <div className="row">
                <div className="col-md-9">
                  <h3 className="card-title">Filtros</h3>
                </div>
                <div className="col-md-3 text-right">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => setShowAddModal(true)}
                  >
                    Adicionar filtro
                  </button>
                </div>
              </div> */}
              <p className="mb-0 mt-1">
                Veja aqui as configurações dos filtros aplicados em seu usuário.
              </p>
              <p className="mb-0">
                As palavras-chaves possuem codificação específica para cobrir variações e possíveis
                erros nas publicações.
              </p>
              <p>
                Caso tenha alguma dúvida,
                <button
                  type="button"
                  className="btn btn-link p-1"
                  onClick={() => {
                    openSupportChat();
                  }}
                >
                  clique aqui
                </button>
                e entre em contato com nossa equipe de atendimento.
              </p>
              <h3>Meus filtros</h3>
              <p>Veja aqui as configurações dos filtros aplicados ao seu usuário.</p>
              <div className="row">
                <div className="col-md-12">
                  <table className="table table-striped">
                    <tbody>
                      {my_account?.my_filters?.map((filter) => (
                        <tr>
                          <td className="align-middle w-75">{filter?.nome_filtro}</td>
                          <td className="align-middle">
                            <button
                              type="button"
                              className="btn btn-link m-0"
                              onClick={() => handleClickView(filter)}
                            >
                              Visualizar
                            </button>
                            {/* <button
                              type="button"
                              className="btn btn-link m-0"
                              onClick={() => handleEdit(filter)}
                            >
                              Editar
                            </button> */}
                            {/* <button
                              type="button"
                              className="btn btn-link m-0"
                              onClick={() => handleExclusion(filter?.nome_filtro)}
                            >
                              Excluir
                            </button> */}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <h3 className="mt-3">Todos os filtros da conta</h3>
              <p>Veja aqui as configurações dos filtros aplicados em sua empresa.</p>
              <div className="row">
                <div className="col-md-12">
                  <table className="table table-striped">
                    <tbody>
                      {my_account?.filters_client?.map((filter) => (
                        <tr>
                          <td className="align-middle w-75">{filter?.nome_filtro}</td>
                          <td className="align-middle">
                            <button
                              type="button"
                              className="btn btn-link m-0"
                              onClick={() => handleClickView(filter)}
                            >
                              Visualizar
                            </button>
                            {/* <button
                              type="button"
                              className="btn btn-link m-0"
                              onClick={() => handleEdit(filter)}
                            >
                              Editar
                            </button> */}
                            {/* <button
                              type="button"
                              className="btn btn-link m-0"
                              onClick={() => handleExclusion(filter?.nome_filtro)}
                            >
                              Excluir
                            </button> */}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}
        </div>
      ) : (
        <div>
          <button type="button" className="btn btn-link" onClick={() => setView('filters')}>
            <img className="mr-2" src={Seta} alt="seta" /> Voltar para Filtros
          </button>
          <ViewFilter
            dadosFilters={dadosFilters}
            setShowEditModal={setShowEditModal}
            showEditModal={showEditModal}
            usuarios={my_account?.users_filters}
          />
        </div>
      )}

      {/* <ExclusionModal action="filtro" name={filterName} /> */}
      <ModalAddFilter
        setShowAddModal={setShowAddModal}
        showAddModal={showAddModal}
        users_filter={my_account?.users_filters}
      />
      {/* {dataFilter.length !== 0 && (
        <EditFilterModal
          setShowEditModal={setShowEditModal}
          showEditModal={showEditModal}
          dataFilter={dataFilter}
          users_filter={my_account?.users_filters}
        />
      )} */}
    </div>
  );
};

export default MyFilters;
